import $ from 'jquery';

/** This sets up buttons or anchors that are supposed to show modals.
 * The button/anchor needs to have data-modal-url in the tag
 * Including data-modal-id is a best practice as it eliminates multiple modals
 **/
$('body').on('click', 'button[data-modal-url], a[data-modal-url]', function() {
    var url = $(this).attr('data-modal-url');
    var modalId = $(this).attr('data-modal-id');

    if ($(this).attr('data-modal-id').length) {
        // Is the modal already in the DOM?
        if($('#'+modalId).length) {
            // Show the existing one
            $('#'+modalId).modal('show');
            return false;
        }
    }

    var data = {'modalId':modalId};

    // Fetch the modal from the server
    $.ajax({
        type: "GET",
        url: url,
        data: data,
        error: function(data) {
            displayToast(data.responseJSON);
        },
        success: function(data) {
            var test_modal_string = 'data-labcoat="do_not_inject"';
            if (data.indexOf(test_modal_string) === -1) {
                // add the modal to the DOM and show it
                $('body').append(data);
            } else {
                // modal is in testing mode -- redirect
                window.location = url + '?modalId=' + modalId;
            }
        }
    });
});

/**
 * when setting up a modal that contains Vuejs components, call initializeVueById() instead of modalAjaxSetup
 */
window.initializeVueById = function(dom_id) {
    if (typeof window.initializedModals == typeof undefined) {
        window.initializedModals = [dom_id];
    } else {
        if (window.initializedModals.indexOf(dom_id) >= 0) {
            return;
        }
        window.initializedModals.push(dom_id);
    }
    const vueApp = document.getElementById(dom_id)

    if(vueApp){
        const modal = new Vue({
            el: `#${dom_id}`,
        });
        window.modalAjaxSetup(dom_id);
        window.deleteSetup();
    }
}

// Pass this the modalId as a string.  The modalId is required.
// If you want to use more options, pass in an options object in the following format:
// { modalId: 'string', success: function() { //do some stuff }, error: function() { // do some different stuff } }
window.modalAjaxSetup = function(options) {
	var modalId = '';
	if (typeof options == 'string') {
		modalId = options;
	} else if (typeof options == 'object') {
		modalId = options['modalId'];
	}

	if (modalId == '') {
		return "Error: The required modalId was not set";
	}

	var $modalId = $('#'+modalId);

	var $form = $modalId.find('form');

    // Set up the success button
    $modalId.find('[name="default-success"]').click(function() {
        var $button = $(this);
        if ($button.attr("data-executing")) {
            return;
        }
        $button.attr("data-executing", true);

        $button.addClass('ajax-active');
        $button.removeClass('btn-success');

        // Get key elements from the form
        var method = $form.prop('method');
        var action = $form.prop('action');

        // Get the form elements and serialize them.
        // This is done because checkboxes can have the same name like colors[]
        var data= [] ;
        $form.find('select, input, textarea, .ajax-input').each(function() {
            var $this = $(this);
            var text = encodeURIComponent($this.prop('name'))+"="+encodeURIComponent($this.val());
            if($this.is(':checkbox') || $this.is(':radio')) {
                if($this.prop('checked')) {
                    data.push(text);
                }
            } else {
                data.push(text);
            }
        });

        $modalId.find('.errorField').removeClass('errorField');

        var dataString = data.join('&');

        $.ajax({
            type: method,
            url: action,
            data: dataString,
            error: function(data) {
                // Is there a custom function
                if (typeof options['error'] == 'function') {
                    options['error'](data);
                } else {
                    // Do the standard error handling
                    $button.children('.ajax-indicator').popover('hide');
                    $button.removeClass('ajax-active');

                    // Laravel 5.5 will present any error messaging in responseJSON.message.
                    // it's helpful to not swallow this information.
                    if (typeof(data.responseJSON.message) == "string" && typeof(data.responseJSON.errors) == "object") {
                        var errors = data.responseJSON.errors;
                    } else {
                        //backward-compatible error message processing for Laravel < 5.5
                        var errors = data.responseJSON;
                    }

                    let messages = _.forEach(errors, function(error, field) {
                        $modalId.find("[name="+field+"]").addClass("errorField");
                        return error.toString();
                    });

                    displayError($modalId.find('.errorMessage'), messages);
                }
                $button.removeAttr("data-executing");
            },
            success: function(data) {
                // Turn off the ajax button
                $button.children('.ajax-indicator').popover('hide');
                $button.removeClass('ajax-active');
                $modalId.find('.errorField').removeClass('errorField');

                // Is there a custom function
                if (typeof options['success'] == 'function') {
                    options['success'](data);
                } else {
                    location.reload();
                }
                $button.attr("data-executing", 'true');
            },
        });
    });

    $modalId.on('shown.bs.modal', function () {
        $(this).find('[autofocus]:first').trigger('focus');
    });

    if (typeof options == 'object') {
        $modalId.modal(options);
    }
    $modalId.modal('show');
}

//login modal
window.display_login_modal = function(url){

    var modalId = "loginModal";

    if (modalId.length) {
        // Is the modal already in the DOM?
        if($('#'+modalId).length) {
            // Show the existing one
            $('#'+modalId).modal('show');
            return false;
        }
    }

    var data = {'modalId':modalId};

    // Fetch the modal from the server
    $.ajax({
        type: "GET",
        url: url,
        data: data,
        error: function(data) {
            displayToast(data.responseJSON);
        },
        success: function(data) {
            $('#main-content').append(data);
        }
    });

}
window.close_login_modal = function(data){
    $('#'+ data ).modal('hide');
}
